@for (row of rows().controls; track $index) {
    <div class="fields row oil" [formGroup]="row">
        @for (circuit of circuits; track circuit.key) {
            <div class="field">
                <span class="label">{{ circuit.label }}</span>
                <div class="quantity">
                    <kendo-numerictextbox [formControlName]="circuit.key" format="#.##" [decimals]="2" [min]="0" [spinners]="false"></kendo-numerictextbox>
                    <kendo-dropdownlist [formControlName]="circuit.key + 'Unit'" [data]="units()"></kendo-dropdownlist>
                </div>
            </div>
        }
    </div>
}
